/**
 * Feel Awsm · Kollagen Elixier Funnel
 * Scoped to #feelawsm-kollagen-funnel (Shopify-safe, Dawn pattern).
 * Add-to-cart mirrors assets/product-form.js (sections in POST, XHR for selling plans, renderContents + open).
 */
(function () {
    "use strict";

    var ROOT_ID = "feelawsm-kollagen-funnel";
    var root = document.getElementById(ROOT_ID);
    if (!root) {
        return;
    }
    if (root.dataset.kelInit === "1") {
        return;
    }
    root.dataset.kelInit = "1";
    document.documentElement.classList.add("kel-js");

    var funnelCfg = {};
    var cfgEl = document.getElementById("FeelawsmKollagenFunnelConfig");
    if (cfgEl && cfgEl.textContent) {
        try {
            funnelCfg = JSON.parse(cfgEl.textContent);
        } catch (e) {
            funnelCfg = {};
        }
    }
    var addingLabel =
        funnelCfg && typeof funnelCfg.addingLabel === "string" && funnelCfg.addingLabel
            ? funnelCfg.addingLabel
            : "Adding…";

    // ============ SCROLL REVEAL ============
    var observerOptions = { threshold: 0.1, rootMargin: "0px 0px -40px 0px" };
    var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("kel-in");
                revealObserver.unobserve(entry.target);
            }
        });
    }, observerOptions);
    root.querySelectorAll(".kel-reveal").forEach(function (el) {
        revealObserver.observe(el);
    });

    // ============ FAQ ACCORDION (<details>, only one open at a time) ============
    var faqItems = root.querySelectorAll(".kel-faq-item");
    faqItems.forEach(function (item) {
        item.addEventListener("toggle", function () {
            if (item.open) {
                faqItems.forEach(function (other) {
                    if (other !== item && other.open) {
                        other.open = false;
                    }
                });
            }
        });
    });

    // ============ STICKY CART SHOW/HIDE ============
    var sticky = root.querySelector("#kel-sticky");
    var hero = root.querySelector(".kel-hero");
    var ticking = false;
    function setStickyPadding(show) {
        root.classList.toggle("kel-has-sticky", !!show);
    }
    window.addEventListener("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                var y = window.pageYOffset || document.documentElement.scrollTop;
                var threshold = hero ? (hero.offsetTop + hero.offsetHeight - 120) : 600;
                if (sticky) {
                    if (y > threshold) {
                        sticky.classList.add("kel-show");
                        setStickyPadding(true);
                    } else {
                        sticky.classList.remove("kel-show");
                        setStickyPadding(false);
                    }
                }
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    // ============ SMOOTH ANCHOR SCROLL (offset for sticky bar) ============
    root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            var href = anchor.getAttribute("href");
            if (!href || href.length < 2 || href === "#") {
                return;
            }
            var target = document.querySelector(href);
            if (!target) {
                return;
            }
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.pageYOffset - 60;
            window.scrollTo({ top: top, behavior: "smooth" });
        });
    });

    // ============ INGREDIENTS "SHOW ALL" TOGGLE ============
    var blocksToggle = root.querySelector(".kel-blocks-toggle button");
    var blocksWrap = root.querySelector(".kel-blocks");
    if (blocksToggle && blocksWrap) {
        blocksToggle.addEventListener("click", function () {
            var open = blocksWrap.classList.toggle("kel-show-all");
            blocksToggle.textContent = open
                ? (blocksToggle.dataset.lessLabel || "Show fewer ingredients ↑")
                : (blocksToggle.dataset.moreLabel || "See all 16 ingredients ↓");
        });
    }

    // ============ COLLAGEN CALCULATOR ============
    var calcBtn = root.querySelector(".kel-calc-btn");
    if (calcBtn) {
        calcBtn.addEventListener("click", function () {
            var ageInput = root.querySelector("#kel-calc-age");
            var age = parseInt(ageInput && ageInput.value, 10) || 35;
            var gender = (root.querySelector('input[name="kel-gender"]:checked') || {}).value || "female";
            var meno = (root.querySelector('input[name="kel-meno"]:checked') || {}).value || "no";
            var stressEl = root.querySelector("#kel-calc-stress");
            var stress = (stressEl && stressEl.value) || "medium";
            var smoke = (root.querySelector('input[name="kel-smoke"]:checked') || {}).value || "no";
            var supp = (root.querySelector('input[name="kel-supp"]:checked') || {}).value || "no";

            var base = 100 - Math.max(0, (age - 25) * 1.5);
            if (gender === "female") base -= 2;
            if (meno === "yes") base -= 12;
            if (stress === "medium") base -= 5;
            if (stress === "high") base -= 13;
            if (smoke === "yes") base -= 8;
            if (supp === "yes") base += 6;
            base = Math.max(18, Math.min(100, Math.round(base)));

            var scoreEl = root.querySelector("#kel-result-score");
            var catEl = root.querySelector("#kel-result-cat");
            var msgEl = root.querySelector("#kel-result-msg");
            var boostEl = root.querySelector("#kel-boost");
            var fillEl = root.querySelector("#kel-prog-fill");
            var panel = root.querySelector("#kel-result");

            if (scoreEl) scoreEl.textContent = base + "%";
            if (fillEl) {
                fillEl.style.width = base + "%";
                if (base >= 75) fillEl.style.background = "linear-gradient(90deg,#5A8A5A,#7AB87A)";
                else if (base >= 55) fillEl.style.background = "linear-gradient(90deg,#C4973A,#E8C06A)";
                else fillEl.style.background = "linear-gradient(90deg,#B8446A,#E890B0)";
            }

            var cat, msg, boost;
            if (base >= 80) {
                cat = "🟢 Good Level";
                msg = "Your collagen level is still well preserved. Now is the perfect time to act before the decline becomes more visible. Many women at your level start noticing the first signs in 2–3 years.";
                boost = "💡 Recommendation: 1 stick daily — focus on stress protection. Ashwagandha is especially important to keep your level where it is.";
            } else if (base >= 65) {
                cat = "🟡 Moderate Decline";
                msg = "Your collagen level is showing the first real losses. This is where subtle changes become noticeable — slightly less firmness, slower nail growth, slightly less hair volume.";
                boost = "💡 Recommendation: 1 stick daily for 8–12 weeks. Week 6: first visible changes expected. Focus on Vitamin C activation and keeping stress low.";
            } else if (base >= 50) {
                cat = "🟠 Noticeable Decline";
                msg = "Your collagen level is significantly below where it should be. The effects are likely already noticeable — skin, hair, nails, possibly joints. Your body needs active support now.";
                boost = "💡 Recommendation: Start with 1.5 sticks daily for 4–8 weeks, then drop to 1 stick. The complete 16-ingredient system is essential at this level.";
            } else {
                cat = "🔴 Critical Level";
                msg = "Your collagen level shows substantial losses. This likely explains several things you notice daily. Without support covering all four steps, recovery is slow.";
                boost = "💡 Recommendation: Start the Boost Phase immediately — 1.5 sticks daily for 8 weeks. All 16 ingredients working together is essential at this level.";
            }
            if (catEl) catEl.textContent = cat;
            if (msgEl) msgEl.textContent = msg;
            if (boostEl) boostEl.textContent = boost;
            if (panel) {
                panel.classList.add("kel-show");
                panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        });
    }

    // ============ CART DRAWER INTEGRATION (Dawn pattern — mirrors product-form.js) ============
    function getCartUi() {
        return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    function getCartAddUrl() {
        var cartAddPath =
            typeof routes !== "undefined" && routes.cart_add_url
                ? String(routes.cart_add_url)
                : "/cart/add";
        if (cartAddPath.charAt(0) === "/" && cartAddPath.indexOf("cart") !== -1) {
            return cartAddPath.replace(/\/cart\/add\/?$/, "/cart/add.js");
        }
        return "/cart/add.js";
    }

    function parseQuantity(btn) {
        var q = parseInt(btn.getAttribute("data-quantity"), 10);
        if (!isNaN(q) && q > 0) {
            return q;
        }
        return 1;
    }

    function fetchSectionHtmlForCart(cart, data, doRender) {
        if (data.sections || !cart || typeof routes === "undefined" || !routes.cart_url) {
            doRender(data);
            return Promise.resolve();
        }
        var sectionIds = cart.getSectionsToRender().map(function (s) {
            return s.id;
        });
        return Promise.all(
            sectionIds.map(function (id) {
                return fetch(routes.cart_url + "?section_id=" + id, { cache: "no-store" }).then(function (r) {
                    return r.text();
                });
            })
        )
            .then(function (htmls) {
                var sections = {};
                sectionIds.forEach(function (id, i) {
                    sections[id] = htmls[i];
                });
                doRender(Object.assign({}, data, { sections: sections }));
            })
            .catch(function () {
                doRender(data);
            });
    }

    root.querySelectorAll(".js-feelawsm-funnel-atc").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            if (btn.getAttribute("aria-disabled") === "true") {
                return;
            }

            var cart = getCartUi();
            var vid = parseInt(btn.getAttribute("data-variant-id"), 10);
            var spRaw = btn.getAttribute("data-selling-plan") || "";
            var quantity = parseQuantity(btn);

            if (!vid || isNaN(vid)) {
                alert("Missing variant");
                return;
            }

            var sellingPlanId = null;
            if (String(spRaw).trim() !== "") {
                var spNum = parseInt(spRaw, 10);
                if (!isNaN(spNum)) {
                    sellingPlanId = spNum;
                }
            }

            var item = { id: vid, quantity: quantity };
            if (sellingPlanId != null) {
                item.selling_plan = sellingPlanId;
            }

            var body = { items: [item] };
            if (cart) {
                if (typeof cart.setActiveElement === "function") {
                    cart.setActiveElement(document.activeElement);
                }
                if (sellingPlanId == null) {
                    body.sections = cart.getSectionsToRender().map(function (section) {
                        return section.id;
                    });
                    body.sections_url = window.location.pathname;
                }
            }

            var addUrl = getCartAddUrl();
            var bodyString = JSON.stringify(body);

            var previousHtml = btn.innerHTML;
            btn.innerHTML = "";
            btn.appendChild(document.createTextNode(addingLabel));
            btn.classList.add("feelawsm-funnel-atc--loading");
            btn.setAttribute("aria-busy", "true");
            btn.setAttribute("aria-disabled", "true");

            var cartAddPromise =
                sellingPlanId != null
                    ? new Promise(function (resolve, reject) {
                          var xhr = new XMLHttpRequest();
                          xhr.open("POST", addUrl, true);
                          xhr.setRequestHeader("Content-Type", "application/json");
                          xhr.setRequestHeader("Accept", "application/json");
                          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                          xhr.onload = function () {
                              if (xhr.status < 200 || xhr.status >= 400) {
                                  reject(new Error("Cart add failed: " + xhr.status));
                                  return;
                              }
                              try {
                                  resolve(JSON.parse(xhr.responseText));
                              } catch (err) {
                                  reject(err);
                              }
                          };
                          xhr.onerror = function () {
                              reject(new Error("Cart add network error"));
                          };
                          xhr.send(bodyString);
                      })
                    : fetch(addUrl, {
                          method: "POST",
                          headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                              "X-Requested-With": "XMLHttpRequest",
                          },
                          body: bodyString,
                      }).then(function (response) {
                          if (!response.ok) {
                              throw new Error("Cart add failed: " + response.status);
                          }
                          return response.json();
                      });

            cartAddPromise
                .then(function (response) {
                    if (response.status) {
                        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                            publish(window.PUB_SUB_EVENTS.cartError, {
                                source: "feelawsm-kollagen-funnel",
                                productVariantId: String(vid),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                        }
                        var desc = (response.description || response.message || "Could not add to cart").toString();
                        alert(desc);
                        return;
                    }

                    if (!cart) {
                        if (typeof routes !== "undefined" && routes.cart_url) {
                            window.location.href = routes.cart_url;
                        } else {
                            window.location.href = "/cart";
                        }
                        return;
                    }

                    if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                        publish(window.PUB_SUB_EVENTS.cartUpdate, {
                            source: "feelawsm-kollagen-funnel",
                            productVariantId: String(vid),
                            cartData: response,
                        });
                    }
                    window.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

                    var doRender = function (data) {
                        cart.renderContents(data);
                    };

                    if (cart.classList && cart.classList.contains("is-empty")) {
                        cart.classList.remove("is-empty");
                    }

                    return fetchSectionHtmlForCart(cart, response, doRender);
                })
                .catch(function (err) {
                    console.warn("[feelawsm-funnel]", err);
                    var msg = (err && err.message) || "Could not add to cart";
                    alert(msg);
                })
                .finally(function () {
                    btn.innerHTML = previousHtml;
                    btn.classList.remove("feelawsm-funnel-atc--loading");
                    btn.removeAttribute("aria-busy");
                    btn.removeAttribute("aria-disabled");
                });
        });
    });
})();
